import { ReactNode } from 'react';
import cx from 'classnames';

//importação da estilização
import '../styles/question.scss';

type QuestionProps = {
    content: string;
    author: {
        name: string;
        avatar: string;
    };
    children?: ReactNode;
    isAnswered?: boolean;
    isHighligted?: boolean;
}

export function Question({
    content,
    author,
    children,
    isAnswered = false,
    isHighligted = false,
}: QuestionProps) {
    return(
        <div 
        className={cx(
            'question', 
            {answered: isAnswered},
            {hilighted: isHighligted && !isAnswered},
        )}>
            <p>{ content }</p>
            <footer>
                <div className="user-info">
                    <img src={ author.avatar } alt={ author.name } />
                    <span>{ author.name }</span>
                </div>
                <div>{ children }</div>
            </footer>
        </div>
    );
}